<!--库存管理-->
<template>
<div class="page-box" ref="pageBox">
    <!--功能区域-->
    <ctrl-box class="ctrl-box" :data="{}" v-reheight="ctrlBoxHeightChanged">

        <view-selector @change="changeViews" :type="viewType" ref="viewSelectofRef"></view-selector>

        <el-link :underline="false" @click="getData(true)">
            <div class="wrap" >
                <icon-svg icon-class="icon-huotaitongbu" font-size="27px;"/>
                <span class="txt" >{{msg('刷新')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="showQuery = !showQuery">
            <div class="wrap" >
                <icon-svg icon-class="icon-search" font-size="27px;"/>
                <span class="txt" >{{msg('搜索')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="showSelectTotal">
            <div class="wrap" >
                <icon-svg icon-class="icon-zongshu" font-size="27px;"/>
                <span class="txt" >{{msg('总数')}}</span>      
            </div>                
        </el-link>
        <inventory-ctrl title="新增" width="100px" icon="icon-tianjia">
            <template>
                <el-link class="ctrl-item" :underline="false" @click="add(0)" v-if="hasPermission('inventory:create')">
                    <icon-svg icon-class="icon-tianjia" font-size="20px;"/>
                    <span class="txt">{{msg('预报库存')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="add(1)" v-if="hasPermission('inventory:create')">
                    <icon-svg icon-class="icon-tianjia" font-size="22px;"/>
                    <span class="txt">{{msg('新增库存')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
        <!-- <el-link :underline="false" @click="edit()">
            <div class="wrap" >
                <icon-svg icon-class="icon-bianji2" font-size="27px;"/>
                <span class="txt" >{{msg('编辑')}}</span>      
            </div>                
        </el-link> -->
        <el-link :underline="false" @click="doImport()" v-if="hasPermission('inventory:create')">
            <div class="wrap" >
                <icon-svg icon-class="icon-daoru3" font-size="27px;"/>
                <span class="txt" >{{msg('导入')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="checkCodeInStore()">
            <div class="wrap" >
                <icon-svg icon-class="icon-saomaruku" font-size="27px;"/>
                <span class="txt" >{{msg('扫码入库')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="inoutStore()" v-if="hasPermission('stock:qtyEdit')">
            <div class="wrap" >
                <icon-svg icon-class="icon-rukuchuku" font-size="27px;"/>
                <span class="txt" >{{msg('入库出库')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="kuaidihuowu()">
            <div class="wrap" >
                <icon-svg icon-class="icon-kuaidihuowu" font-size="27px;"/>
                <span class="txt" >{{msg('快递货物')}}</span>      
            </div>                
        </el-link>
        <el-link :underline="false" @click="renling()">
            <div class="wrap" >
                <icon-svg icon-class="icon-kuaiditongbu" font-size="27px;"/>
                <span class="txt" >{{msg('认领库存')}}</span>      
            </div>                
        </el-link>
        <inventory-ctrl title="智能理货" width="100px" icon="icon-zhinenglihuo">
            <template>
                <el-link class="ctrl-item" :underline="false" @click="expressFenjian" v-if="hasPermission('stock:expSort')">
                    <icon-svg icon-class="icon-zhinenglihuo" font-size="20px;"/>
                    <span class="txt">{{msg('快递分拣')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="inventoryFenjian" v-if="hasPermission('stock:stockSort')">
                    <icon-svg icon-class="icon-zhinenglihuo" font-size="22px;"/>
                    <span class="txt">{{msg('库存分拣')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
        <el-link :underline="false" @click="batchUpdate()">
            <div class="wrap" >
                <icon-svg icon-class="icon-pilianggengxin1" font-size="27px;"/>
                <span class="txt" >{{msg('批量更新')}}</span>      
            </div>                
        </el-link>
        <inventory-ctrl title="导出" width="100px" icon="icon-daochu2">
            <template>
                <el-link class="ctrl-item" :underline="false" @click="doExport()">
                    <icon-svg icon-class="icon-daochu" font-size="20px;"/>
                    <span class="txt">{{msg('导出列表')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="doExportTrace()">
                    <icon-svg icon-class="icon-rukuchuku" font-size="22px;"/>
                    <span class="txt">{{msg('出入记录')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
        <inventory-ctrl title="打印" width="100px" icon="icon-dayin2">
            <template>
                <el-link class="ctrl-item" :underline="false" @click="printShelfCode(0)" v-if="hasPermission('inventory:print')">
                    <icon-svg icon-class="icon-dayin2" font-size="20px;"/>
                    <span class="txt">{{msg('架位标签')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="printShelfCode(1)" v-if="hasPermission('inventory:print')">
                    <icon-svg icon-class="icon-dayin2" font-size="22px;"/>
                    <span class="txt">{{msg('产品标签')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="printShelfCode(2)" v-if="hasPermission('inventory:print')">
                    <icon-svg icon-class="icon-dayin2" font-size="22px;"/>
                    <span class="txt">{{msg('架位详签')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
        <inventory-ctrl title="退件" width="100px" icon="icon-daochu">
            <template>
                <el-link class="ctrl-item" :underline="false" @click="reback(0)" v-if="hasPermission('inventory:reback')">
                    <icon-svg icon-class="icon-daochu" font-size="20px;"/>
                    <span class="txt">{{msg('申请退件')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="reback(1)" v-if="hasPermission('inventory:reback')">
                    <icon-svg icon-class="icon-daochu" font-size="20px;"/>
                    <span class="txt">{{msg('平台退件')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="rebackCancel" v-if="hasPermission('inventory:reback')">
                    <icon-svg icon-class="icon-daochu" font-size="22px;"/>
                    <span class="txt">{{msg('取消退件')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="receivedBack()" v-if="hasPermission('inventory:reback')">
                    <icon-svg icon-class="icon-daochu" font-size="22px;"/>
                    <span class="txt">{{msg('受理退件')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="exportBack()" v-if="hasPermission('inventory:reback')">
                    <icon-svg icon-class="icon-daochu1" font-size="22px;"/>
                    <span class="txt">{{msg('导出资料')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" @click="importBack()" v-if="hasPermission('inventory:reback')">
                    <icon-svg icon-class="icon-daoru3" font-size="22px;"/>
                    <span class="txt">{{msg('导入单号')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
        <!-- <el-link :underline="false" @click="traces()">
            <div class="wrap" >
                <icon-svg icon-class="icon-trace" font-size="27px;"/>
                <span class="txt" >{{msg('记录')}}</span>      
            </div>                
        </el-link> -->
        <el-link :underline="false" @click="doDelete()" v-if="hasPermission('inventory:delete')">
            <div class="wrap" >
                <icon-svg icon-class="icon-shanchu1" font-size="27px;"/>
                <span class="txt" >{{msg('删除')}}</span>      
            </div>                
        </el-link>
        <column-settings v-if="allColumns" @refresh-column="refreshColumn" col-key="INVENTORY_VIEW_COLUMNS" :all-columns="allColumns"/>
        <inventory-ctrl title="帮助" width="100px" icon="el-icon-question">
            <template>
                <el-link class="ctrl-item" :underline="false" target="_blank" href="https://kdocs.cn/l/cjxRJqDZXNmi" >
                    <span style="padding: 5px 0px;" class="txt">{{msg('库存管理')}}</span>
                </el-link>
                <el-link class="ctrl-item" :underline="false" target="_blank" href="https://www.kdocs.cn/l/crkiDiNs0ggL" >
                    <span style="padding: 5px 0px;" class="txt">{{msg('现货操作')}}</span>
                </el-link>
            </template>
        </inventory-ctrl>
    </ctrl-box>
    <div class="empty-fixed-box" v-bind:style="{height:emptyFixedBoxHeight}"></div>
    <!--查询区域-->
    <transition name="el-zoom-in-top">
        <query-box :query="query" v-show="showQuery" labelWidth="80px">
            <template v-slot:default="scope">
                <template v-for="q in scope.query.queries" >
                    <el-form-item :key="q.id" v-if="q.disabled == 0" :label="q.nlabel? q.nlabel : q.label" >
                        <span v-if="q.type == 0">
                            <el-input v-if="q.op != 6" v-model="q.dvalue" :placeholder="q.placeholder"  clearable>
                            </el-input>
                            <el-input v-else type="textarea" v-model="q.dvalue" :rows="2" 
                                :placeholder="q.placeholder"  clearable></el-input>
                        </span>
                        <el-input v-else-if="q.type == 1" v-model="q.dvalue" :placeholder="q.placeholder"  clearable></el-input>
                        <span v-else-if="q.type == 2">
                            <el-select v-if="q.op === 0" v-model="q.dvalue" size="mini" clearable :placeholder="q.placeholder">
                                <el-option v-for="d in getDicts(q.filterOptionKey)" 
                                    :key="d.value" :label="d.label" :value="d.value">
                                </el-option>
                            </el-select>
                            <el-select v-else v-model="q.dvalues" multiple size="mini" clearable :placeholder="q.placeholder">
                                <el-option v-for="d in getDicts(q.filterOptionKey)" 
                                    :key="d.value" :label="d.label" :value="d.value">
                                </el-option>
                            </el-select> 
                        </span>
                        <el-date-picker v-if="q.type == 3" clearable
                            v-model="q.dvalues" value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-date-picker v-if="q.type == 4" clearable
                            v-model="q.dvalues" value-format="yyyy-MM-dd HH:mm:ss"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </el-form-item>
                </template>
                <span style="margin-left:12px;">
                    <el-checkbox v-model="isInventory" @change="getQtys">查看库存</el-checkbox>
                </span>
                <el-row>
                    <el-button type="primary" icon="el-icon-search" @click="getData(true)" size="mini">{{msg('搜索')}}</el-button>
                    <el-button icon="el-icon-refresh" size="mini" @click="reset" >{{msg('重置')}}</el-button>
                </el-row>
            </template>
        </query-box>
    </transition>

    <!--表格区域-->
    <div class="table-wrap">
        <div class="nav-tag">
            <el-tag :effect="query.statusStr==='10,85'?'dark':'plain'" @click="doNav('10,85')">可用库存</el-tag>
            <el-tag :effect="query.statusStr==='5'?'dark':'plain'" @click="doNav('5')">预报库存</el-tag>
            <el-tag :effect="query.statusStr==='95,100,135'?'dark':'plain'" @click="doNav('95,100,135')">历史库存</el-tag>
            <el-tag :effect="query.statusStr==='105,107,110'?'dark':'plain'" @click="doNav('105,107,110')">退件快递</el-tag>
            <el-tag :effect="query.statusStr=='-1'?'dark':'plain'" @click="doNav('-1')">全部</el-tag>
        </div>
        <vxe-grid ref="dataTable" :height="docHeight"  
            resizable border="full" stripe
            export-config
            highlight-current-row highlight-hover-column highlight-current-column
            show-overflow show-header-overflow 
            :data="datas"
            size="mini"
            :columns="columns"
            :scroll-x="{gt: 20}"
            :scroll-y="{gt: 20}"
            @cell-click="clickRow"
            :checkbox-config="{highlight:true, trigger: 'cell'}"
        ></vxe-grid>

        <pagenator @page-change="handlerPageChange" :query="query" >
        </pagenator>
    </div>

    <!-- 组件区域 -->
    <!--编辑库存-->
    <inventory-edit ref="inventoryEditRef" @finish="closeEdit"/>
    <!-- 状态记录 -->
    <inventory-trace ref="inventoryTraceRef"/>
    <!-- 入库出库记录 -->
    <inventory-out-trace ref="inventoryOutTraceRef"/>
    <!-- 申请退件 -->
    <inventory-back ref="inventoryBackRef" @finish="closeBack"/>
    <!-- 快递货物 -->
    <inner-exp-code-dg ref="kuaidiRef" />
    <!-- 快递分拣 -->
    <express-sorting ref="expressSortingRef" />
    <!-- 库存分拣 -->
    <stock-sorting ref="expStockRef"  />
    <!-- 导入退件单号 -->
    <inventory-back-import ref="importBackRef" @finish="closeEdit"/>


    <drawer :title="msg('批量更新指定内容')" :width="isMinScreen?'100%':'50%'"
        :content-width="'100%'"
        :visible.sync="batchUpdateVisible">
            <batch-update :datas="batchDatas" @close-dg="closeBatchUpdateDialog" ref="batchUpdateRef"/>
    </drawer>

    <drawer :title="msg('库存编辑')" :width="isMinScreen?'100%':'30%'"
        :content-width="'100%'" @opened="openEditDrawer"
        :visible.sync="editDrawerVisible">
        <inventory-edit-drawer :inventory="editDrawerData" @close-dg="closeEditDrawerDialog" ref="invEditDrawerRef"/>
    </drawer>

    <el-dialog :title="msg('打印标签')" :visible.sync="printTagVisible" :fullscreen="isMinScreen" @opened="openPrintTagDg"
        :close-on-click-modal="false" 
            width="600px" >
        <inventory-print-tag ref="printTagDg" @closed="printTagVisible=false"/>
    </el-dialog>

    <el-dialog :title="msg('导出出入记录')" :visible.sync="exportVisible" :fullscreen="isMinScreen" @opened="openExportDg"
        :close-on-click-modal="false"  
            width="600px" >
        <export ref="exportDg" @close-dg="closeExportDg"/>
    </el-dialog>

</div>
</template>

<script>
import Pagenator from "../../components/Pagination.vue";
import CtrlBox from "../../components/CtrlBox.vue";
import QueryBox from "../../components/QueryBox.vue";
import InventoryColumns from "./InventoryColumns.js";
import InventoryEdit from "./InventoryEdit.vue";
import InventoryTrace from "./InventoryTrace.vue";
import InventoryOutTrace from "./InventoryOutTrace.vue";
import InventoryCtrl from "./InventoryCtrl.vue";
import ColumnSettings from "../../components/ColumnSettings.vue";
import XmDrawer from "../../components/XmDrawer.vue";
import BatchUpdate from "./InventoryBatchUpdate.vue";
import InventoryPrintTag from "./InventoryPrintTag.vue";
import InventoryBack from "./InventoryBack.vue";
import InventoryEditDrawer from './InventoryEditDrawer.vue';
import InnerExpCodeDg from "./InnerExpCodeExpress.vue";
import ExpressSorting from "../store/ExpressSorting.vue";
import StockSorting from "../store/StockSorting.vue";
import ViewSelector from "../../components/ViewSelector.vue";
import InventoryBackImport from "./InventoryBackImport.vue";
import Export from "./Export.vue";
import axios from "axios";
import {
    openWindowWithPost,
} from "../store/StockService.js"

const COL_KEY = "INVENTORY_VIEW_COLUMNS";

export default {
    name: "inventory",
    components: {
        Pagenator:Pagenator,
        CtrlBox: CtrlBox,
        QueryBox: QueryBox,
        InventoryEdit: InventoryEdit,
        InventoryTrace: InventoryTrace,
        InventoryOutTrace: InventoryOutTrace,
        InventoryCtrl:InventoryCtrl,
        ColumnSettings:ColumnSettings,
        Drawer : XmDrawer,
        BatchUpdate:BatchUpdate,
        InventoryPrintTag:InventoryPrintTag,
        InventoryBack:InventoryBack,
        InventoryEditDrawer:InventoryEditDrawer,
        InnerExpCodeDg:InnerExpCodeDg,
        ExpressSorting:ExpressSorting,
        StockSorting:StockSorting,
        ViewSelector: ViewSelector,
        InventoryBackImport:InventoryBackImport,
        Export:Export
    },
    mounted: async function(){

        this.user  = JSON.parse(localStorage.getItem("user"));

        //初始化字段
        let savedCols =  [];
        this.allColumns = InventoryColumns.allColumns;
        let savedColumnResult = await this.$axios.get(this.$kit.api.user.configs+"?groups="+COL_KEY);
        if(savedColumnResult && savedColumnResult.data[COL_KEY]){
            let savedColumns = JSON.parse(savedColumnResult.data[COL_KEY][0].xvalue);
            if(savedColumns){
                for(let key in savedColumns){ //{key: 1, key:0}
                    let checked = savedColumns[key] ? true: false;
                    let col = this.allColumns.find(i => i.field == key);
                    if(col && checked){
                        savedCols.push(col);
                    }
                }
            }
        }
        
        if(savedCols.length == 0){
            this.allColumns.forEach(c => {
                savedCols.push(c);
            })
        }
        this.columns = InventoryColumns.buildColumns(this.$createElement, this, savedCols);
        //初始化状态
        this.statuses =  [
            {label: "已入仓", value: 10, type: "success"},
            {label: "已拆包", value: 85, type: "primary"},
        ];
        //初始仓储类型
        this.storeTypes = this.dicts.inventoryStoreTypes;
        //采购平台
        this.productOrigins = this.dicts.productOrigin;
        //初始化库存
        this.getStores();

        this.$nextTick(()=>{
            // 获取指定元素
            const scrollview = this.$refs['pageBox']
            scrollview.addEventListener('scroll', (view)=>{
                // console.log("滚动中");
            }, true);

            this.$refs.viewSelectofRef.getDefaultView((view)=> {
                this.viewSetting = view;
                this.buildQueries(view.queries);
                this.getData(true);
            });

        });
    },
    data(){
        return {
            emptyFixedBoxHeight: '37px',
            query: {
                length: 100,
                start: 0,
                pageIndex:1,
                pageTotal: 0,
               
                statusStr:'-1',
                queries: null,
                
            },

            viewType: 2, //库存视图
            storeTypes: [],  //仓储类型列表
            productOrigins:[], //采购平台列表
            statuses: [],  //状态列表
            showQuery: false,  //是否显示查询区域
            datas: null,
            columns: [],
            allColumns: null,
            totalCount: [],
            batchUpdateVisible:false,
            batchDatas:[],
            printIds:null,
            printType:null,
            printTagVisible:false,
            editDrawerVisible:false,
            editDrawerData:null,
            stores:[],

            viewsVisiable: null,
            viewSetting: null,
            viewFilterText: null,
            views:null,
            loadMored:false,
            exportVisible:false,

            isInventory: false,
            
        }
    },
    directives: {
        reheight: {
            bind(el, binding) {
                let height = '';
                function isReheight() {
                    const style = document.defaultView.getComputedStyle(el);
                    if (height !== style.height) {
                        binding.value(style.height);
                    }
                    height = style.height;
                }
                el.__vueSetInterval__ = setInterval(isReheight, 300);
            },
            unbind(el) {
                clearInterval(el.__vueSetInterval__);
            }
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
        docHeight: {  //表格的高度
            get() {
                var height =  this.$store.state.docHeight;
                return height - 260;
            }
        },
        routeTab: {
            get(){
                try{
                    return this.$store.state.activeMenus[this.$route.path]
                }catch{
                    return null;
                }
            }
        }
    },
    methods: {
        getStores(){
            //获取仓库列表
            this.$axios.get(this.$kit.api.store.listUsed)
            .then((result) => {
                if(result.status){
                    let data = result.data;
                    // data.splice(0, 0, {id: 0, name: '空'});
                    this.stores.splice(0,this.stores.length);
                    this.stores = data;
                }
            });
        },
        changeViews(view){
            this.viewSetting = view;
            if(view.queries){
                this.buildQueries(view.queries);
                // this.query.queries = view.queries;
            }
            this.getData(true);
        },
        //初始化查询条件
        buildQueries(qs){
            qs.forEach(q => {

                if(q.dvalue || q.dvalue === 0){

                    if(q.type == 3){ //3-表示是时间类型
                        let curr = new Date();
                        let prevTime =  curr.getTime() - (q.dvalue * 24 * 3600 * 1000);
                        let prev;
                        if(q.dvalue == 1){
                            prev = curr;
                        }else{
                            prev = new Date(prevTime);
                        }
                        q.dvalue = null;
                        let nv = [this.$kit.fmtDate(prev), this.$kit.fmtDate(curr)];
                        this.$set(q,'dvalues',nv);
                    }else if(q.type == 4){//日期时间类型
                        let curr = new Date();
                        let prevTime =  curr.getTime() - (q.dvalue * 24 * 3600 * 1000);
                        let prev = new Date(prevTime);
                        let nv =  [this.$kit.fmtDateTime(prev), this.$kit.fmtDateTime(curr)];
                        q.dvalue = null;
                        this.$set(q,'dvalues',nv);
                    }else if(q.op == 6 || q.op == 8){ //表示可以有多个值
                        let nv = q.dvalue.split(",").map(v => (v*1 || v));
                        this.$set(q,'dvalues',nv);
                    }else{
                        let val = q.dvalue;
                        let val1 = val*1;
                        q.dvalue = val1 || val;
                        this.$set(q,'dvalues', []);
                    }
                }else{
                    this.$set(q,'dvalues', []);
                }
            });
            
            this.query.queries = qs;
            return qs;
        },
        //获取列表数据
        getData(refresh){
            if(refresh){
                this.query.pageIndex = 1;
                this.query.start = 0;
                // this.selectedRows = [];
            }

            let param = this.$kit.rebuildQuery(this.query);
            // if(param.inventoryCodes){
            //     param.inventoryCodes = param.inventoryCodes.split(/[\r\n,]+/ig).filter(s => s);
            // }

            // if(param.inCodes){
            //     param.inCodes = param.inCodes.split(/[\r\n,]+/ig).filter(s => s);
            // }

            if(this.query.queries){
                let queries = []; 
                this.query.queries.forEach(e => {
                    let values = e.dvalues;
                    let value = e.dvalue;

                    let q = {
                        dvalue: e.dvalue,
                        tableName: e.tableName,
                        colName: e.colName,
                        op: e.op,
                        type: e.type,
                        tableAlias: e.tableAlias
                    }
                    if(q.type == 0 && q.op == 6){
                        if(value){
                            value = value.split(/[\s,]+/);
                            q.dvalue = value.join(",");
                            queries.push(q);
                        }
                    }else{
                        if(q.type == 3 || q.op == 6 || q.op==8 || q.type == 4){
                            if(values && values.length>0){
                                q.dvalue = values.join(",");
                                queries.push(q);
                            }else if(value){
                                queries.push(q); 
                            } 
                        }else if(q.dvalue || q.dvalue === 0){
                            queries.push(q);
                        }
                    }
                });
                param["queries"] = queries;
            }
           
            this.$axios.post(
                this.$kit.api.inventory.list, 
                param
            ).then((result) => {
                // this.$message(result.msg);
                if(result.status){
                    this.datas = result.data.list;
                    this.query.pageTotal = result.data.total;
                    //查询统计
                    // this.getQtys(this.datas.map(d => d.id));
                }
            });

        },
        //获取销量和在途数量那些字段
        getQtys(){
            if(!this.isInventory){
                return;
            }

            let ids = this.datas.map(d => d.id);
            axios.request({
                url: this.$kit.api.inventory.listCount, 
                method: 'post',
                headers: {"Content-Type":"application/json; charset=utf-8",
                        "X-Requested-With":"XMLHttpRequest",
                    },
                withCredentials: true,
                data: ids,
            }).then((result) => {
                if(result.status){
                    let resData = result.data.data;
                    if(resData){
                        this.datas.forEach(e => {
                            resData.forEach(e1 => {
                                if(e.id == e1.id){
                                    e.cgQty = e1.cgQty;
                                    e.ztQty = e1.ztQty;
                                    e.sevenQty = e1.sevenQty;
                                    e.monthQty = e1.monthQty;
                                    e.totalCount = e1.totalCount;
                                }
                            })
                        })
                    }
                }
            });
        },
        doNav(statusStr){
            this.query.statusStr = statusStr;
            if (statusStr == '-1') {
                this.statuses = this.dicts.inventoryStatuses;
            }else{
                this.statuses = [];
                let statuss = statusStr.split(',');
                statuss.forEach(e => {
                    let storeType = this.dicts.inventoryStatuses.find(d => d.value === +e);
                    this.statuses.push(storeType);
                })
            }
            
            this.getData(true);
        },
        ctrlBoxHeightChanged(height){
            this.emptyFixedBoxHeight = height;
        },
        //刷新列表字段
        refreshColumn(cols){
            this.columns = InventoryColumns.buildColumns(this.$createElement, this, cols)
        },
        reset(){
            // this.$kit.clearQuery(this.query);
            this.query.inventoryCodes = null;
            this.query.inCodes = null;
            this.query.status = [];
            this.query.inCode = null;
            this.query.shelfCode = null;
            this.query.title = null;
            this.query.spec = null;
            this.query.sku = null;
            this.query.variationSku = null;
            this.query.storeName = null;
            this.query.storeType = [];
            this.query.companyName = null;
            this.query.origin = null;
            this.query.subCodes = null;
            this.query.creater = null;
            this.query.productOrigin = [];
            this.query.Date = [];
            this.query.InDate = [];
            this.query.Expire = [];
            this.isInventory = false;
            if(this.query.queries){
                this.query.queries.forEach(e => {
                    if(e.disabled == 0){
                        if(e instanceof Array){
                            e.dvalues = [];
                        }else{
                            e.dvalues = null;
                        }
                        if(e.hasOwnProperty('dvalue')){
                            e.dvalue = null; 
                        }
                    }
                })
            }
        },
        add(item){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            this.$refs.inventoryEditRef.showAdd(item, selectes.length>0?selectes[0]: null);
        },
        // edit(){
        //     var selectes = this.$refs.dataTable.getCheckboxRecords();
        //     if(selectes.length>0){
        //         this.$refs.inventoryEditRef.showEdit(selectes[0]);
        //     }
        // },
        doEditRow(row){
            var _this = this;
            this.$axios.get(this.$kit.api.inventory.get+"?id="+row.id)
                .then((result) => {
                    if(result.status){
                        let data = result.data;
                        let allowEdit = true;
                        if(!data.backAccept || data.backAccept == this.user.username){
                            allowEdit = false;
                        }
                        _this.editDrawerData = {
                            id:data.id,
                            code:data.code,
                            sku:data.sku,
                            variationSku:data.variationSku,
                            spec:data.spec,
                            title:data.title,
                            backCode:data.backCode,
                            productOrigin:data.productOrigin,
                            productLink:data.productLink,
                            safeQty:data.safeQty,
                            price:data.price?(data.price/100).toFixed(2):0,
                            cost:data.cost?(data.cost/100).toFixed(2):0,
                            amtBack:data.amtBack?(data.amtBack/100).toFixed(2):0,
                            thumbId:data.thumbId,
                            status:data.status,
                            backAccept:data.backAccept,
                            allowEdit:allowEdit
                        };
                        _this.editDrawerVisible = true;

                    }
                })
        },
        closeEdit(refresh){
            if(refresh){
                this.getData();
            }
        },
        closeYubao(refresh){
            if(refresh){
                this.getData();
            }
        },
        doDelete(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            let ok = true;
            selectes.forEach(e => {
                if(e.status != 5 && e.status != 135) {
                    ok = false;
                }
            })

            let userId  = this.user.id;
            if(!ok && userId != 1){
                this.$message(this.msg('只能删除待入仓和已弃件的数据'));
                return;
            }
            this.$confirm('确定要删除库存吗?', this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.inventory.deletes, selectes.map(s => s.id).join(","))
                    .then((result) => {
                        this.$message(result.msg);
                        if(result.status){
                            this.getData();
                        }
                    });
            }).catch((err) => {
                // console.log(err);
            });
        },
        //分页发生变化的回调函数
        handlerPageChange(info){
            this.query.length = info[0];
            this.query.start = info[1];
            // this.selectedRows = [];
            this.getData();
        },
        clickRow({row,rowIndex, $event, column, columnIndex}){
            let className = $event.target.className;
            if(column.property == 'id'){  //查看，编辑，详情
                if(className.indexOf('edit-cell')>-1){
                    var _this = this;
                    // _this.kit.strongAuth(function () {
                      //执行正常操作
                      _this.doEditRow(row);
                    // }, _this);
                }
            }else if(column.property == 'status'){//打开物流记录
                if(!this.hasPermission("stoce:openStockTrack")){
                    this.$message(this.msg('非超级会员，不能点击直接查看！'));
                    return;
                }
                if(className.indexOf('status-cell')>-1){
                    var table =  this.$refs.dataTable;
                    table.clearCheckboxRow();
                    table.setCheckboxRow([row], !table.isCheckedByCheckboxRow(row))

                    var selectes = this.$refs.dataTable.getCheckboxRecords();
                    if(selectes.length>0){
                        let row = selectes[0];
                        this.$refs.inventoryOutTraceRef.showTracks(row.id, row.code);
                    }

                }
            }
        },
        traces(){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length>0){
                this.$refs.inventoryTraceRef.showTracks(selectes[0].id, selectes[0].code);
            }
        },
        doImport(){
            this.$tabs.open ("/admin/inventory/import");//导入EXCEL
        },
        checkCodeInStore(){//扫码入库
            this.$tabs.open("/admin/stock/checkCodeIn");
        },
        inoutStore(){//入库出库
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            let ids = selectes.map(e => e.id).join(",");
            window.localStorage.setItem("qtyEditIds", ids);
            this.$tabs.open("/admin/stock/qty-edit");
        },
        doExport(){
            this.$refs.dataTable.openExport({ isPrint: false })
        },
        batchUpdate(){//批量更新
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            if(selectes.length>5000){
                this.$message(this.msg('单次不能超过5000条数据'));
                return;
            }

            this.batchDatas = [];
            selectes.forEach(s =>  {
                this.batchDatas.push({
                    id: s.id,
                    key: s.code,
                    value: null,
                    label: null,
                    result: null
                });
            });
            this.batchUpdateVisible = true;
        },
        closeBatchUpdateDialog(type){
            if(type){
                this.getData();
            }
            this.batchUpdateVisible = false;
        },
        closeEditDrawerDialog(type){
            if(type){
                this.getData();
            }
            this.editDrawerVisible = false;
        },
        printShelfCode(type){//打印架位标签
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.printIds = selectes.map(s=>s.id).join(",");
            this.printType = type;
            this.printTagVisible = true;
        },
        openPrintTagDg(){
            this.$nextTick(() => {
                this.$refs.printTagDg.init(this.printIds,this.printType);
            });
        },
        openExportDg(){
            this.$nextTick(() => {
                this.$refs.exportDg.init();
            });
        },
        openEditDrawer(){
            this.$nextTick(() => {
                this.$refs.invEditDrawerRef.init(this.editDrawerData);
            });
        },
        reback(type){//0-申请退件|1-平台退件
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length>1){
                this.$message(this.msg('只能单个申请！'));
                return;
            }
            let select = selectes[0];
            let status = +select.status;
            let storeType = +select.storeType;
            if(status != 10 && status != 85 && status != 95){
                //|| storeType != 20 || storeType != 25
                this.$message(this.msg('状态是已入仓、已拆包、转寄中的库存才可申请退件！'));
                return;
            }

            this.$refs.inventoryBackRef.showDialog(selectes[0].id, selectes[0].code, type);
        },
        closeBack(refresh){
            if(refresh){
                this.getData();
            }
        },
        rebackCancel(){//取消退件
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            this.$confirm('确定要取消退件吗?', this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.inventoryOut.cancelBack,selectes.map(s=>s.id).join(","))
                    .then((result) => {
                        if(result.status){
                            let data = result.data;
                            this.$message("成功取消"+data+"条退件");
                            this.getData();
                        }else{
                            this.$message(result.msg);
                        }
                    });
            }).catch((err) => {
                // console.log(err);
            });
        },
        receivedBack(){//受理退件
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            let ok = true;
            selectes.forEach(e => {
                let status = e.status;
                if(status != 105){
                    ok = false;
                }
            })

            if(!ok){
                this.$message(this.msg('受理失败！选择的货物中存在不能退件货物，请检查！'));
                return;
            }

            this.$prompt("请输入受理退件批次", this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
            }).then(({ value }) => {
                this.$axios.post(this.$kit.api.inventoryOut.receiveBack+"?v="+value, selectes.map(s=>s.id).join(","))
                    .then((result) => {
                        this.$message(result.msg);
                        if(result.status){
                            this.getData();
                        }
                    });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消输入'
                });
            });
        },
        kuaidihuowu(){//快递货物
            this.$refs.kuaidiRef.showDialog();
        },
        expressFenjian(){//快递分拣
            this.$refs.expressSortingRef.showDialog();
        },
        inventoryFenjian(){//库存分拣
            this.$refs.expStockRef.showDialog();
        },
        formatStoreType({ cellValue }){
            let status = this.dicts.inventoryStoreTypes.find(d => d.value === cellValue);
            return status?.label || cellValue;
        },
        formatStoreStatus({ cellValue }){
            let status = this.dicts.inventoryStatuses.find(d => d.value === cellValue);
            return status?.label || cellValue;
        },
        formatOrigin({ cellValue }){
            let status = this.dicts.productOrigin.find(d => d.value === cellValue);
            return status?.label || cellValue;
        },
        exportBack(){//退件导出资料
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length==0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }
            if(selectes.length > 1000){
                this.$message(this.msg('数据过多'));
                return;
            }
            window.open(this.$kit.api.inventory.exportBack+"?ids="+selectes.map(s=>s.id).join(","),"_blank")
        },
        importBack(){//导入
            this.$refs.importBackRef.show();
        },
        doExportTrace(){//导出出入记录
            // var selectes = this.$refs.dataTable.getCheckboxRecords();
            // if(selectes.length==0){
            //     this.$message(this.msg('请选中一条数据进行操作'));
            //     return;
            // }
            // if(selectes.length > 500){
            //     this.$message(this.msg('数据过多'));
            //     return;
            // }
            // window.open(this.$kit.api.inventory.exportTrace+"?ids="+selectes.map(s=>s.id).join(","),"_blank")
            //打开时间选择弹窗
            this.exportVisible = true;
        },
        closeExportDg(date){
            if(date){
                var selectes = this.$refs.dataTable.getCheckboxRecords();
                if(selectes.length==0){
                    selectes = this.$refs.dataTable.getData();
                }
                if(selectes.length > 2000){
                    this.$message(this.msg('单次导出数量不能大于1000'));
                    return;
                }
                this.exportVisible = false;
                let starDate = date[0];
                let endDate = date[1];
                // window.open(this.$kit.api.inventory.exportTrace+"?ids="+selectes.map(s=>s.id).join(",")+'&startDate='+starDate+'&endDate='+endDate,"_blank")
                openWindowWithPost(
                        this.$kit.api.inventory.exportTrace,
                        {
                            ids:selectes.map(s=>s.id).join(","),
                            startDate:starDate,
                            endDate:endDate,
                        }
                    );
            }else{
                this.exportVisible = false;
            }
        },
        showSelectTotal(){//总数
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            let total = 0;
            if(selectes.length > 0){
                total = selectes.length;
            }
            this.$message({message:'当前选中：'+total+"条",type:"success"});
        },
        renling(){//认领库存
            this.$confirm('确定要认领库存吗?', this.msg('提示'), {
                confirmButtonText: this.msg('确定'),
                cancelButtonText: this.msg('取消'),
                type: 'warning'
            }).then(() => {
                this.$axios.post(this.$kit.api.inventory.renlingInventory)
                    .then((result) => {
                        this.$message(result.msg);
                    });
            }).catch((err) => {
                // console.log(err);
            });
        },
    }
}

</script>

<style lang="scss" scoped>

.page-box{overflow-y:auto;}
.ctrl-box{position: absolute;z-index:99;width:100%;}
.empty-fixed-box{height:57.5px;}
.status-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.edit-cell{cursor:pointer; display:inline-block; margin-right:5px;}
.ctrl-item{
    display:block;
}
.ctrl-item::v-deep(.el-link--inner){
    display:flex;
    align-items: center;
}
.nav-tag span{
  margin:0px 10px 5px 0px;
  cursor: pointer;
}
</style>